import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import {NotificationGroup, mount_carousel} from '@bitstillery/common/components/portal'
import {api} from '@bitstillery/common/app'

import {$s} from '@/app'
import {ShellHeader} from '@/cms/components/shell/header/header'

import {toggle_tawk} from '@/lib/tawk'
import {load_product_photos} from '@/models/offer'

import {PanelMenu} from '@/components/panels'

export class LayoutPortal extends MithrilComponent {
    private was_on_shop_surface = false

    override async oncreate() {
        toggle_tawk(true)
        // Prime the favourites badge so the header notification bubble is accurate
        // on any authenticated surface, not only after the first shop visit.
        if ($s.identity.token) {
            void this.refresh_favourites_stats()
        }
        const url_params = m.parsePathname(m.route.get()).params
        if ('show_popup_of' in url_params) {
            const offer_item_artkey = Number(url_params.show_popup_of)
            await load_product_photos([offer_item_artkey])
            // A failed photo lookup leaves no entry, and the carousel can't render without slides.
            const photos = $s.product_photos[offer_item_artkey]
            if (photos) {
                mount_carousel({
                    controls: true,
                    current: 0,
                    indicators: true,
                    slides: photos.map((photo) => ({url: photo.image_location})),
                    type: 'fullscreen',
                })
            }
        }
    }

    private async refresh_favourites_stats() {
        try {
            const {result, success} = await api.get('portal/offer-items/favourites/statistics')
            if (!success) return
            $s.offers.updated_favourites = result.updated_favourites
            $s.offers.favourites = result.total_favourites
        } catch {
            // Non-blocking: badge can stay stale until next shop visit
        }
    }

    override onupdate() {
        toggle_tawk(true)
        const route = m.route.get()
        const on_shop = route.startsWith('/shop')
        if ($s.identity.token && on_shop && !this.was_on_shop_surface) {
            void this.refresh_favourites_stats()
        }
        this.was_on_shop_surface = on_shop
    }

    view(vnode: m.Vnode) {
        const route = m.route.get()
        const is_cms_layout = !route.startsWith('/shop')
        const is_shop_layout = !is_cms_layout

        const show_bar = Boolean($s.identity.token) && !is_cms_layout

        const portal_mobile_overlay_skip_submenu_row = (show_bar && is_shop_layout) || (is_cms_layout && !show_bar)
        return [
            <div
                className={classes('l-main-col', {
                    'header-collapsed': $s.page.header.collapsed,
                    'cms-layout': is_cms_layout,
                    'shop-layout': !is_cms_layout,
                    'portal-mobile-shop-no-breadcrumbs': portal_mobile_overlay_skip_submenu_row,
                })}
                key={$s.env.key}
            >
                <ShellHeader />
                <PanelMenu />
                {vnode.children}
            </div>,
            <div className='portal-notifications-host' key={`${$s.env.key}-notifications`}>
                <NotificationGroup notifications={$s.notifications} />
            </div>,
        ]
    }
}
